import styled from 'styled-components';

const SearchBoxStyle = styled.div`
  .flexContainer {
    display: flex;
    flex-wrap: wrap;
    width: 1226px;
    min-height: 818px;
    padding: 25px 26px 18.3px 0px;
    background-color: #f5f5f5;
    margin-left: 22px;
    margin top : 50px;
  }

  .parentGrid {
    min-height: 768px;
    display: grid;
    grid-template-columns: repeat(4,1fr);
    grid-auto-rows: 314px;
  }

   .parentGrid > .childBox {
    width: 275px;
    height: max-content;
    margin: 25px 0px 45px 26px;
    padding: 1px 1px 17.7px;
    border-radius: 4px;
    border: solid 1px #eaeaea;
    background-color: #ffffff;
  }

  .upperBox {
    object-fit: cover
    width: 273px;
    height: 176px;
    margin: 0 0 14px;
    border-radius: 3px;
    background-color: #f5f5f5;
  }

  .lowerBox {
    display: block;
  }
  .boardName{
    float:left;
    width: 200px;
    margin: 14px 0px 5px 23px;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #2c2c2c;
  }

  .items {
    float: right;
    margin-top: 8px;
  }
`;

export default SearchBoxStyle;

export const TableBox = styled.div`
  grid-area: tableBox;
  width: 1240px;
  min-height: 420px;
`;
